import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { CalculatedFees, calculateFees, FeesPayload } from "../requests";

export function useGetPaymentFees({
  base_amount,
  program_id,
  ...options
}: FeesPayload & Omit<UseQueryOptions<CalculatedFees>, 'queryKey' | 'queryFn'>) {
  
  return useQuery({
    queryKey: ['calculateFees', base_amount, program_id],
    queryFn: async () => await calculateFees({
      base_amount,
      program_id,
    }),
    ...options
  });
}